import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import axiosInstance from 'axiosConfig';
import { Toast } from 'components';
import { TOAST_TYPES_ENUM } from 'enums';
import { queryClient } from 'App';

type SkirtingBoardInstallationInfoData = {
  measurementUuid: string;
  acrylation: boolean;
  plannedAssemblyTime: string;
  numberOfAssemblyTeams: string;
  comments?: string;
};

const usePutSkirtingBoardInstallationInfo = (
  options?: UseMutationOptions<any, Error, SkirtingBoardInstallationInfoData>
) => {
  return useMutation({
    ...options,
    mutationKey: ['editSkirtingBoardInstallationInfo'],
    mutationFn: async (data) => {
      return axiosInstance
        .put('/measurement/skirting-board/installation-info', data)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      Toast({
        message: 'Przetwarzanie danych instalacji listew przypodłogowych...',
        type: TOAST_TYPES_ENUM.LOADING,
        id: 'edit-skirting-board-installation-info',
      });
      if (options && options.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      Toast({
        message: 'Dane instalacji listew przypodłogowych zaktualizowane pomyślnie.',
        type: TOAST_TYPES_ENUM.SUCCESS,
        id: 'edit-skirting-board-installation-info',
      });
      queryClient.invalidateQueries({ queryKey: ['skirtingBoardInstallationInfo'] });
      if (options && options.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      Toast({
        message: 'Błąd podczas aktualizacji danych instalacji listew przypodłogowych.',
        type: TOAST_TYPES_ENUM.ERROR,
        id: 'edit-skirting-board-installation-info',
      });
      if (options && options.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};

export default usePutSkirtingBoardInstallationInfo;
